"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _commonMedia = _interopRequireDefault(require("../styles/common-media.css"));
var applyDarkTheme = function applyDarkTheme(data, theme) {
  return data.theme === 'dark' ? theme[data.theme] : '';
};
var VideoBackgroundButton = function VideoBackgroundButton(_ref) {
  var data = _ref.data,
    videoIsPlaying = _ref.videoIsPlaying,
    toggleVideoPlay = _ref.toggleVideoPlay,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(applyDarkTheme(data, theme), _commonMedia["default"].buttonWrapper)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: _commonMedia["default"].videoControlsButton + " " + theme.dark,
    onClick: function onClick() {
      return toggleVideoPlay(videoIsPlaying);
    },
    name: videoIsPlaying ? 'Pause' : 'Play'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (videoIsPlaying ? theme.mmcIconPause : theme.mmcIconPlay) + " " + _commonMedia["default"].videoControlsIcon + " "
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "" + _commonMedia["default"].offScreen
  }, videoIsPlaying ? 'Pause' : 'Play')));
};
var _default = VideoBackgroundButton;
exports["default"] = _default;